import { useState } from "react";
import { useAcceptCgRequestMutation, useGetCgRequestsQuery, useRejectCgRequestMutation, useRespondCgRequestMutation } from "../../redux/service/careGiver_service";
import { BtnComponent, parseResponse } from "../../utils/common_lib";
import { toast } from "react-toastify";
import MainPageDialog from "../../components/mainPageDialog";

export const CaregiverRequests = ({reqList}) => {
    const [rejReason, setRejReason] = useState(null);
    const [reasonError, setReasonError] = useState(false);
    const [Request, setRequest] = useState(null);
    const [confirmReject, setConfirmReject] = useState(false);

    const [acceptCgRequest, {isLoading: accepting}] = useAcceptCgRequestMutation();
    const [rejectCgRequest, {isLoading: rejecting}] = useRejectCgRequestMutation();

    const resetValues = () => {
        setRejReason(null);
        setReasonError(false);
        setRequest(null);
        setConfirmReject(false);
    }

    const confirmAction = (req, act) => {
        setRequest(req);
        if(act == 'reject'){
            setConfirmReject(true);
        }else{
            respondPendingRequest(req, act)
        }
    }

    const respondPendingRequest = async(request, act) => {
        let postFn;
        let postParams = {
          request_id:request.id,
        }
        if(act == 'reject'){
            postFn = rejectCgRequest;
            if(rejReason){
                postParams.reject_reason = rejReason;
                setReasonError(false);
            }else{
                setReasonError(true);
                return;
            }
        }else{
            postFn = acceptCgRequest;
        }
        const res = await postFn(postParams, act);
        resetValues();
        const {code, msg} = parseResponse(res);
        if(code == 0){
            toast.success(msg);
        }else{
            toast.error(msg);
        }
    }
    const rejectionFooter = [
        {type: 'close', title: 'Cancel', action: () => resetValues()},
        {type: 'save', title: 'Proceed', action: () => respondPendingRequest(Request, 'reject')}
    ]
    const displayAddress = req => {
        let address = '';
        ['street', 'city', 'state'].map(item => {
            if(req[item]){
                address += address === '' ? '' : ', ';
                address += req[item];
            }
        });
        return address === '' ? '' : <p className="capitalize text-sm mt-2">{address}</p>;
    }

    return (
        <>
            {reqList?.map((req, reqIndex) => {
                return (
                    <div className="border-b border-slate-400 p-2 flex gap-2" key={`pending_request_${reqIndex}`}>
                        <div className="flex-1">
                            <p>
                                <span className="text-lg">{req.full_name}</span>
                                {req.relation && <span className="text-sm ml-1">({req.relation})</span>}
                            </p>
                            {displayAddress(req)}
                        </div>
                        <div className="flex-none">
                            <BtnComponent 
                            loading={accepting && Request?.id == req.id}
                            text="Accept" 
                            btnType="primary" 
                            onClick={() => {confirmAction(req, 'accept')}} />
                            <BtnComponent 
                            loading={rejecting && Request?.id == req.id}
                            className="ml-2"
                            text="Reject" 
                            btnType="danger" 
                            onClick={() => confirmAction(req, 'reject')} />
                        </div>
                    </div>
                )
            })}
            {!reqList?.length ? <p className="p-2 text-center">No requests found.</p> : ''}

            {/* dialogs */}
            {confirmReject && 
            <MainPageDialog
                contentCls="h-[600px] p-2"
                maxHeight={true}
                title="Confirm Reject"
                modalSize="small"
                footerList={rejectionFooter}
                onCancelHandler={() => resetValues()}
            >
                <>
                    <p>Are you sure, you want to reject this request?</p>
                    <div className="w-full">
                        <div className={`pointer-events-none font-normal mb-2 ${reasonError ? "text-red-600" : "text-gray-600"} text-left`}>
                            Reason
                            <span className="text-red-500 p-2">*</span>
                        </div>
                        <div
                            className={`px-3 py-1 relative w-full border border-gray-300 bg-white rounded 
                            ${reasonError ? "focus-within:border-red-600 border-red-600" : ""}`}
                        >
                        <textarea 
                        className={`block w-full appearance-none focus:outline-none bg-transparent focus:ring-0 text-base font-light text-black-300`}
                        placeholder="Provider reason"
                        onChange={e => {setRejReason(e.target.value);}}
                        value={rejReason}
                        name="reason"></textarea>
                        </div>
                        {reasonError && (
                            <p className=" text-xs text-red-600 h-3" id="email-error">
                                Please provide reason.
                            </p>
                        )}
                    </div>
                </>
            </MainPageDialog>}
        </>
    )
}